<div class="conversation__messages" #messagesContainerRef>
  <div class="conversation__thread">
    <sgt-chat-skeleton *ngIf="loadingHistory"></sgt-chat-skeleton>

    <ng-container *ngIf="!loadingHistory">
      <div class="conversation__welcome-slot" *ngIf="!messages.length">
        <ng-content select="[chat-welcome]"></ng-content>
      </div>

      <ng-container
        *ngFor="let group of messageGroups; trackBy: trackByGroupLabel"
      >
        <div class="conversation__day-separator">{{ group.label }}</div>

        <ng-container
          *ngFor="let msg of group.messages; trackBy: trackByMessageId"
        >
          <div
            class="conversation__activity"
            *ngIf="msg === lastMessage && loading && (activityHeadline || !msg.content)"
          >
            <i
              class="fas fa-circle-notch fa-spin conversation__activity-spinner"
              aria-hidden="true"
            ></i>
            <span>{{ activityHeadline || 'Pensando…' }}</span>
          </div>

          <sgt-chat-message
            [message]="msg"
            [isTyping]="msg === lastMessage && loading"
            (copyMessage)="onCopyMessage($event)"
          ></sgt-chat-message>
        </ng-container>
      </ng-container>

      <sgt-approval-card
        *ngIf="interrupt"
        [interrupt]="interrupt"
        [submitting]="loading"
        (respond)="onRespond($event)"
      ></sgt-approval-card>
    </ng-container>
  </div>
</div>

<div class="conversation__input-area">
  <ng-content select="[chat-input-top]"></ng-content>
  <sgt-chat-input
    #chatInput
    [sessionId]="sessionId"
    [placeholder]="inputPlaceholder"
    [sending]="loadingHistory || loading || !!interrupt"
    [runControl]="runControl"
    [conversationFiles]="conversationFiles"
    (messageSent)="onMessageSent($event)"
    (stopRequested)="onStopRequested()"
  ></sgt-chat-input>
</div>
